/**
 * Application object.
 */
let app;

function calculateMiles(map_lat, map_lng, gym_lat, gym_lng) {
    return (
        Math.acos(
            Math.sin(map_lat * Math.PI / 180) *
            Math.sin(gym_lat * Math.PI / 180) +
            Math.cos(map_lat * Math.PI / 180) *
            Math.cos(gym_lat * Math.PI / 180) *
            Math.cos((map_lng - gym_lng) * Math.PI / 180)
        ) * 180 / Math.PI
    ) * 60 * 1.1515;
}

function calculateKilometers(map_lat, map_lng, gym_lat, gym_lng) {
    Math.radians = function (degrees) {
        return degrees * Math.PI / 180;
    };
    return (
        6371 * Math.acos(
            Math.cos(Math.radians(map_lat)) *
            Math.cos(Math.radians(gym_lat)) *
            Math.cos(Math.radians(gym_lng) - Math.radians(map_lng)) +
            Math.sin(Math.radians(map_lat)) *
            Math.sin(Math.radians(gym_lat))
        )
    );
}

function alignColumnHeights($container, $column, $item) {
    function makeid() {
        let text = "";
        const possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        for (let i = 0; i < 5; i++)
            text += possible.charAt(Math.floor(Math.random() * possible.length));
        return text;
    }

    if (jQuery($container).length > 0) {
        jQuery($container).each(function () {
            const uniqueID = makeid();
            jQuery(this).addClass(uniqueID);
            if (window.innerWidth > 767) {
                let itemTallest = 0,
                    itemHeight = 0;
                jQuery($container + '.' + uniqueID).find($column).each(function () {
                    jQuery(this).find($item).css('height', 'auto');
                    itemHeight = jQuery(this).find($item).outerHeight();
                    if (itemHeight > itemTallest) {
                        itemTallest = itemHeight;
                    }
                    if (jQuery(this).is(':last-child')) {
                        jQuery($container + '.' + uniqueID).find($item).css('height', itemTallest);
                    }
                });
            } else {
                jQuery($container + '.' + uniqueID).find($column).each(function () {
                    jQuery(this).find($item).css('height', 'auto');
                });
            }
        });
    }
}

function alignTabs() {
    if (jQuery('section.tab-content').length > 0) {
        let tabContainerWidth = jQuery('section.tab-content .container').width(),
            tabTotalWidth = 0;
        jQuery('section.tab-content .nav-tabs').children('li').each(function () {
            tabTotalWidth = tabTotalWidth + jQuery(this).outerWidth(true);
            if (jQuery(this).is(':last-child')) {
                if (tabTotalWidth > tabContainerWidth) {
                    jQuery('section.tab-content').addClass('tabs-vertical');
                } else {
                    jQuery('section.tab-content').removeClass('tabs-vertical');
                }
            }
        });

        jQuery('section.tab-content').on('click', '.nav-tabs li a', function () {
            if (jQuery(this).parents('.tabs-vertical').length) {
                if (window.innerWidth > 767) {
                    let docScrollTop = parseInt(jQuery(document).scrollTop()),
                        tabScrollTop = parseInt(jQuery(this).parents('.tabs-vertical').offset().top);
                    if (docScrollTop > tabScrollTop) {
                        jQuery('html, body').animate({
                            scrollTop: (tabScrollTop - 70)
                        }, 500);
                    }
                }
            }
        });

        var hash = document.location.hash;
        if (hash && jQuery('.nav-tabs a[href="'+hash+'"]').length) {
            jQuery('.tab-content .tab-pane').removeClass('active');
            jQuery('.tab-content '+hash).addClass('active');
            setTimeout(function() {
                window.scrollTo(0, 0);
            }, 1);
        }
    }
}

function swapSearchtext() {
    if (jQuery('.find-location-widget').length > 0 || jQuery('.location-finder-sidebar').length > 0) {
        let searchText;
        if (window.innerWidth > 767) {
            searchText = jQuery('#locationFinder input[type=text]').data('placeholder');
        } else {
            searchText = jQuery('#locationFinder input[type=text]').data('placeholder-short');
        }
        jQuery('#locationFinder input[type=text]').attr('placeholder', searchText);
    }
}


function trainingBlockHeight() {
    let maxHeight = 0,
        height;
    jQuery('.training-block .training-body, .gym-coaching .align-items-stretch .bg-white.p-5').css('height', 'auto');
    jQuery('.training-block .training-body, .gym-coaching .align-items-stretch .bg-white.p-5').each(function () {
        height = jQuery(this).outerHeight(true);
        if (height > maxHeight) {
            maxHeight = height;
        }
    });
    jQuery('.training-block .training-body, .gym-coaching .align-items-stretch .bg-white.p-5').css('height', maxHeight);
}


function recalcWhenPromo() {
    if (window.innerWidth > 767 && jQuery('.promo-link').length > 0) {
        if (jQuery('.promo-bar').length > 0 && jQuery('#sticky-anchor').length > 0 && (jQuery('.hero-content').length > 0 || jQuery('.hero-v2').length > 0 ) ) {
            let newHeight = (jQuery('.promo-bar').height() + jQuery('#sticky-anchor').height()),
                mediaPadding = (jQuery('.promo-bar').height() / 2) + jQuery('#sticky-anchor').height();
            if (jQuery('.behind-header').hasClass('hero-gym') || jQuery('.behind-header').hasClass('hero-coaching-training') || jQuery('.behind-header').hasClass('hero-membership') || jQuery('.behind-header').hasClass('thank-you-employee-wellness') || jQuery('.behind-header').hasClass('franchise-form') || jQuery('.behind-header').hasClass('hero-faqs')) { // fix for the banner stands far from the gym info & training & membership & thank-you-employee-wellness & franchise-form & faqs
                jQuery('.behind-header').css('padding-top', newHeight + "px");
            } else {
                jQuery('.behind-header, .hero-content.slim').css('padding-top', newHeight + "px");
            }
            jQuery('.hero-media').css('padding-top', mediaPadding + "px");
        } else if (jQuery('.promo-bar').length > 0 && jQuery('.elementor').length > 0) {
            jQuery('.promo-bar + main .elementor').css('padding-top', "");
        } else {
            if (jQuery('.behind-header').hasClass('hero-coaching-training') || jQuery('.behind-header').hasClass('hero-membership') || jQuery('.behind-header').hasClass('thank-you-employee-wellness') || jQuery('.behind-header').hasClass('franchise-form') || jQuery('.behind-header').hasClass('hero-faqs')) { // fix for the banner stands far from the training & membership & thank-you-employee-wellness & franchise-form & faqs
                jQuery('.hero-media, .hero-v2').css('padding-top', jQuery('.promo-bar').outerHeight()  + "px");
            } else {
                jQuery('.hero-content, .hero-media, .hero-v2').css('padding-top', jQuery('.promo-bar').outerHeight()  + "px");
            }
        }
    }
}

function adjustFranchiseHeader() {
    if (jQuery('.franchise-pages').length > 0) {
        if (window.innerWidth > 767) {
            if (!jQuery('.franchise-pages').hasClass("landing")) {
                jQuery('.franchise-pages').addClass('landing');
            }
        } else {
            if (jQuery('.franchise-pages').hasClass("landing")) {
                jQuery('.franchise-pages').removeClass('landing');
            }
        }
    }
}

function dropdownAlign() {
    if (jQuery('.dropdown').length > 0 && window.innerWidth > 767) {
        jQuery('.dropdown').each(function () {
            // Reset widths
            jQuery(this).find('.btn').css('width', 'auto');
            jQuery(this).find('.dropdown-menu').css('width', 'auto');

            // Set width variables
            let btnWidth = jQuery(this).find('.btn').outerWidth(true),
                dropWidth = jQuery(this).find('.dropdown-menu').outerWidth(true);

            // Check if button or dropdown needs width adjustment
            if (dropWidth > btnWidth) {
                jQuery(this).find('.btn').css('width', dropWidth);
            }
            if (dropWidth < btnWidth) {
                jQuery(this).find('.dropdown-menu').css('width', btnWidth);
            }
        });
    }
}

function dropdownAlignGroup() {
    if (jQuery('.dropdown-group').length > 0 && window.innerWidth > 767) {
        jQuery('.dropdown-group').each(function () {
            let btnWidth = jQuery(this).find('.btn').outerWidth(true),
                dropWidth = jQuery(this).find('.dropdown-menu').outerWidth(true);
            if (dropWidth > btnWidth) {
                var dropOffset = 0 - ((dropWidth - btnWidth) / 2);
                jQuery(this).find('.dropdown-menu').css({
                    'margin-left': dropOffset
                });
            }
        });
    }
}

function dropdownAlignText() {
    jQuery(".dropdown-white .dropdown-menu").on('click', 'li a', function () {
        // Swap selected text in dropdown
        let setText = jQuery(this).text();
        jQuery(this).parents('.btn-group').find('.dropdown-toggle').html(setText + '<span class="caret"></span>');
        dropdownAlign();
    });
}

function allLocationsFilter() {
    if (jQuery('#locFilter').length > 0) {
        let stateFilter = jQuery('#stateFilter'),
            countries_active = active_country,
            states_active,
            states_array,
            set_url;

        jQuery('#locFilter').on('click', '.dropdown-menu li a', function () {
            let states_html = '';

            if (jQuery(this).parents('#countryFilter').length > 0) {
                stateFilter.find('.dropdown-toggle .state-default').html(states_default);
                countries_active = jQuery(this).attr('data-key');
                states_array = countries_array[countries_active]['states'];
                jQuery.each(states_array, function (key, val) {
                    if (val['abbr'] !== null && val['name'] !== null && val['abbr'] !== 'undefined' && val['name'] !== 'undefined') {
                        states_html += '<li class="dropdown-item"><a href="#" data-key="' + val['abbr'] + '"><div class="location-filter-text">' + val['name'] + '</div></a></li>';
                    }
                });
                stateFilter.show().find('.dropdown-menu').html(states_html);
                dropdownAlign();
            }

            if (jQuery(this).parents('#stateFilter').length > 0) {
                states_active = jQuery(this).attr('data-key');
                if (!the_permalink.endsWith('/')) {
                    the_permalink += "/";
                }
                set_url = the_permalink + countries_active.toLowerCase() + '/' + rfc3986EncodeURIComponent(states_active.toLowerCase()) + '/';
                window.location.href = set_url;
            }
        });
    }
}

function rfc3986EncodeURIComponent(str) {
    return encodeURIComponent(str).replace(/[!'()*]/g, escape);
}

function stickyBtnLanding() {
    if (jQuery('.sticky-button').length > 0) {
        let btnOffset;
        if (window.innerWidth > 767) {
            btnOffset = parseInt(jQuery('.sticky-button').offset().top + 13);
            if (jQuery('body.page-template-page-landing-franchise').length > 0) {
                btnOffset = parseInt(jQuery('.sticky-button').offset().top - 106);
            }
        } else {
            btnOffset = parseInt(jQuery('.sticky-button').offset().top - 12);
            if (jQuery('body.page-template-page-landing-franchise').length > 0) {
                btnOffset = parseInt(jQuery('.sticky-button').offset().top - 161);
            }
        }

        if (window.innerWidth == 768) { // fix for iPad
            let navbarHeight = parseInt(jQuery('#navbar').height()) - 2;
            jQuery('.sticky-button').css('top', navbarHeight);
        }

        jQuery(window).scroll(function () {
            let docScrollTop = parseInt(jQuery(document).scrollTop()),
                bottomScreen = jQuery(window).scrollTop() + jQuery(window).innerHeight(),
                topScreen = jQuery(window).scrollTop();

            if (docScrollTop >= btnOffset) {
                jQuery('section.hero').addClass('affix-button').addClass('affix-button-scroll');
                if (window.innerWidth > 767) {
                    jQuery('div[class="sticky-button"]').not('.button-bank-index').css("top", jQuery('nav.navbar').height() + 'px');
                }
            } else if (docScrollTop < btnOffset) {
                jQuery('section.hero').removeClass('affix-button').removeClass('affix-button-scroll');
                if (window.innerWidth > 767) {
                    jQuery('div[class="sticky-button"]').not('.button-bank-index').css("top", '');
                }
            }

            // don't need double the button bank
            if (jQuery('.pricing-buttons').length > 0) {
                let pricingButtonsOffsetTop = jQuery('.pricing-buttons').offset().top,
                    pricingButtonsOffsetBottom = jQuery('.pricing-buttons').offset().top + jQuery('.pricing-buttons').outerHeight();

                if ((bottomScreen > pricingButtonsOffsetTop) && (topScreen < pricingButtonsOffsetBottom)){
                    jQuery('#open_button_bank').slideUp();
                } else {
                    jQuery('#open_button_bank').slideDown();
                }
            }

            if (window.innerWidth <= 767
                && jQuery('section.hero').hasClass('affix-button-scroll')
                && jQuery('section.promo-bar').length > 0
                && (jQuery('section.promo-bar').hasClass('sticky_top') || jQuery('section.promo-bar').hasClass('sticky_bottom')) ) {
                jQuery('div[id$="_button_bank"]').removeClass('sticky-button');
            }


            if (jQuery('section.hero').hasClass('affix-button-scroll')
                && jQuery('section.promo-bar').length == 0
                && jQuery('.hero-v2').length == 0) {
                if (window.innerWidth > 767) {
                    jQuery('div[id$="_button_bank"]').css("top", jQuery('nav.navbar').height() + 'px');
                } else {
                    jQuery('div[id$="_button_bank"]').css("top", '');
                }
            }
        });
    }
}

/** Adjust for offset when clicking links to anchor tags **/
function scrollToHash(onload = false) {
    let hash = window.location.hash, fixedElementHeight = jQuery('header.main').outerHeight();
    if (jQuery(hash).length) {
        if (window.innerWidth <= 767) {
            fixedElementHeight = jQuery('#sticky').outerHeight();
            if (jQuery('section.promo-bar').length > 0) {
                if (jQuery('section.promo-bar').hasClass('fixedTop') || (onload && jQuery(window).scrollTop() > jQuery('nav.navbar').height())) {
                    fixedElementHeight = jQuery('section.promo-bar:visible').outerHeight();
                } else {
                    fixedElementHeight += jQuery('section.promo-bar:visible').outerHeight();
                }
            } else if (!onload || jQuery(window).scrollTop() <= jQuery('nav.navbar').height()) {
                fixedElementHeight = jQuery('header.main').outerHeight();
            }
        }
        jQuery('html, body').animate({scrollTop: (jQuery(hash).offset().top - fixedElementHeight)}, 2);
    }
}

function setPromoStickyTop() {
    let $promoBarStickyTop = jQuery('section.promo-bar.sticky_top');
    if (window.innerWidth <= 767) {
        if (jQuery(document).scrollTop() > jQuery('nav.navbar').height()) {
            $promoBarStickyTop.addClass('fixedTop').css({ "position": "fixed", "top": "0" });
        } else {
            $promoBarStickyTop.removeClass('fixedTop').css({ "position": "inherit", "top": "unset"});
        }
    } else {
        $promoBarStickyTop.removeClass('fixedTop').css("position", "absolute");
    }
}

jQuery(window).on("load", function () {
    trainingBlockHeight();

    if (jQuery('.promo-bar .bg-load').length > 0) {
        jQuery('.promo-bar .bg-load').addClass('loaded');
    }

    jQuery(window).scroll(function () {
        setPromoStickyTop();
    });

    alignColumnHeights('.offers-announcements', '.col-offann', '.offann-item');
    alignColumnHeights('section.column-content .row-bordered', '.col', '.col-content');
    alignColumnHeights('section.column-content .row', '.col.has-bg', '.col-content-text');
    alignColumnHeights('section.icon-group .row', '.col', '.icon-group-content');
    alignColumnHeights('section.icon-group-content .row', '.col', '.icon-group-content');
    alignColumnHeights('section.coaching-training .row', '.col', '.col-content');
    alignColumnHeights('section.blog-posts .row', '.col', '.col-content');
    alignColumnHeights('section.training-icon-group .row', '.col', '.col-content');
    alignTabs();
});

jQuery(document).ready(function ($) {
    swapSearchtext();
    let $win = $(window),
        winWidth = $win.width(),
        $doc = document.documentElement;
    $doc.setAttribute('data-useragent', navigator.userAgent);

    dropdownAlign();
    dropdownAlignGroup();
    dropdownAlignText();
    allLocationsFilter();
    stickyBtnLanding();

    // Label list elements
    $('li:first-child, .item:first-child').addClass('first');
    $('li:last-child, .item:last-child').addClass('last');

    $('form label:not(.no-asterisk)').each(function () {
        let el = $(this),
            input = el.next('input');
        if (typeof input.prop("tagName") === "undefined") {
            input = el.next('select');
        }

        if(input.prop('required') && el.text().indexOf('*') === -1 && el.parents('.elementor-form').length == 0) {
            el.text(el.text().replace(/\s+?$/, '') + '*');
        }
    });

    $("iframe").each(function () {
        let ifr_source = $(this).attr('src');
        if (ifr_source) {
            let wmode = "wmode=transparent";
            if (ifr_source.indexOf('?') >= 0) {
                $(this).attr('src', ifr_source + '&' + wmode);
            } else {
                $(this).attr('src', ifr_source + '?' + wmode);
            }
        }
    });

    if (window.innerWidth > 767) {
        $('header.main li.search a').click(function (e) {
            e.preventDefault();
            $('header.main .main-nav').addClass('search-active');
            setTimeout(function () {
                $('header.main .main-nav .search-form').addClass('active');
            }, 400);
            $('header.main .search-form .search-field').focus();
        });
        $('header.main .search-form .search-close').click(function () {
            $('header.main .main-nav').removeClass('search-active');
            $('header.main .main-nav .search-form').removeClass('active');
        });
    }

    let addEvent = function (elem, type, eventHandle) {
        if (elem == null || elem == undefined) return;
        if (elem.addEventListener) {
            elem.addEventListener(type, eventHandle, false);
        } else if (elem.attachEvent) {
            elem.attachEvent("on" + type, eventHandle);
        }
    };

    function getFontSizeForGym() {
        if (window.innerWidth <= 767 && $('.loc-nav-gym-name').length) {
            $('.loc-nav-name').css('padding-right', '5px');
            let textLength = $('.loc-nav-gym-name').text().length;
            if (textLength < 8) {
                $('.loc-nav-gym-name').css('font-size', '4vw');
            }else if (textLength < 14) {
                $('.loc-nav-gym-name').css('font-size', '3vw');
            }else if (textLength < 19) {
                $('.loc-nav-gym-name').css('font-size', '2.5vw');
            }else if (textLength < 24) {
                $('.loc-nav-gym-name').css('font-size', '2vw');
            } else {
                $('.loc-nav-gym-name').css('font-size', '1.8vw');
            }
        }

    }
    getFontSizeForGym();

    addEvent(window, "resize", function () {
        swapSearchtext();
        recalcWhenPromo();
        adjustFranchiseHeader();
        if (winWidth != $(window).width()) {
            alignColumnHeights('.offers-announcements', '.col-offann', '.offann-item');
            alignColumnHeights('section.column-content .row-bordered', '.col', '.col-content');
            alignColumnHeights('section.column-content .row', '.col.has-bg', '.col-content-text');
            alignColumnHeights('section.icon-group .row', '.col', '.icon-group-content');
            alignColumnHeights('section.icon-group-content .row', '.col', '.icon-group-content');
            alignColumnHeights('section.coaching-training .row', '.col', '.col-content');
            alignColumnHeights('section.blog-posts .row', '.col', '.col-content');
            alignColumnHeights('section.training-icon-group .row', '.col', '.col-content');
            alignTabs();
        }
        setPromoStickyTop();
        getFontSizeForGym();
    });

    $(document).delegate('*[data-toggle="lightbox"]', 'click', function (event) {
        event.preventDefault();
        return $(this).ekkoLightbox({
            onShow: function () {
                jQuery('.ekko-lightbox .modal-body').append('<div class="loader custom"><div class="runner"></div></div>');
            }
        });
    });

    $('.scroll').on('click', function (e) {
        e.preventDefault();

        let href = $(this).attr('href'),
            hash = href.substring(href.indexOf('#'));

        $('html, body').animate({
            scrollTop: (jQuery(hash).offset().top)
        }, 1000);
    });

    $('.people-content, .staff-member').click(function (e) { // old template class and new
        e.preventDefault();
        if ($('.staff-member').length) {
            $(this).closest('section.main').css('z-index', 'auto');
        }
        let curPerson = parseInt($(this).attr('data-person'));
        $('#gymPeopleModal').modal('show');
        $('#gymPeopleSlider').carousel({
            interval: false
        }).carousel(curPerson);
        $('#gymPeopleModal').addClass('in');
        $('.modal-backdrop.fade').addClass('in');
    });

    $('#gymPeopleModal').on('hidden.bs.modal', function () {
        if ($('.staff-member').length) {
            $(this).closest('section.main').css('z-index', '');
        }
    });


    $('#peopleMore').on('show.bs.collapse', function () {
        $('#viewMorePeople').html('View Less');
    }).on('hide.bs.collapse', function () {
        $('#viewMorePeople').html('View More');
    });
    $('footer.main .nav li').each(function () {
        if ($(this).hasClass('form-trigger')) {
            $(this).attr('data-target-form', 'form-contact-feedback');
        }
    });
    $('footer.main .nav > li > .sub-menu > li.menu-item-has-children > a').click(function (e) {
        e.preventDefault();
        $(this).parent().toggleClass('active');
    });

    /*
    * Hide "The Cookie Law" notification.
    * Save confirmed cookie(cookie_notification_confirmed) during user's session.
    * */
    $('.btn-close-cookie-notification').click(function (e) {
        e.preventDefault();
        $(this).closest(".cookie-notification-wrapper").addClass('confirmed');
        document.cookie = "cookie_notification_confirmed=true;path=/";
    });

    // On dropdown open
    $(document).on('shown.bs.dropdown', function (event) {
        let dropdown = $(event.target);

        // Set aria-expanded to true
        dropdown.find('.dropdown-menu').attr('aria-expanded', true);

        // Set focus on the first link in the dropdown
        setTimeout(function () {
            dropdown.find('.dropdown-menu li:first-child a').focus();
        }, 10);
    });

    // On dropdown close
    $(document).on('hidden.bs.dropdown', function (event) {
        let dropdown = $(event.target);

        // Set aria-expanded to false
        dropdown.find('.dropdown-menu').attr('aria-expanded', false);

        // Set focus back to dropdown toggle
        if (!$("body").hasClass("v3-template")) {
            dropdown.find('.dropdown-toggle').focus();
        }
    });

    // If ?verify=false, hide gdpr stuff
    if (window.location && window.location.search && window.location.search.indexOf('verify=false') >= 0) {
        setCookie('af_verify', "false");
    }

    if (getCookie('af_verify', "true") === "false") {
        $('.gdpr').remove();
    }
    recalcWhenPromo();
    adjustFranchiseHeader();
}); // End Doc Ready

// FORMS
let formApp = {};
formApp.gymID = "";

jQuery(function ($) {
    let headerHeightPrevious,
        resizeHeader,
        $locationRegion = $('.form-container select.location-region:not(.do-not-query)'),
        $locationCity = $('.form-container select.location-city'),
        selectedRegion = $('.form-container select.location-region').find("option:selected").val();
    $.fn.selectpicker.Constructor.BootstrapVersion = '4';

    // BOOTSTRAP SELECT
    $('.selectpicker', $('.form-container')).selectpicker({
        style: 'btn',
        size: 6
    });

    function disableStep2onMembershipInquiry() {
        if ($(".stepper-container").length) {
            $('.steps .bridge.step2').removeClass('active');
            $('.steps .marker.step1').addClass('active');
            $('.steps .marker.step2').removeClass('active').addClass('incomplete');
        }
    }

    function enableStep2onMembershipInquiry() {
        if ($(".stepper-container").length) {
            $('.steps .bridge.step2').addClass('active');
            $('.steps .marker.step2').addClass('active').addClass('active');
            $('.steps .marker.step1').addClass('complete').removeClass('active');
        }
    }
    // REGION DROPDOWN -> Grab region's gyms
    $locationRegion.on('change', function () {
        let $stateProvinceSelect = $(this),
            $thisForm = $(this).parents('form'),
            selectedStateId = $stateProvinceSelect.find("option:selected").data('stateId'),
            selectedStateAbbr = $stateProvinceSelect.find("option:selected").val(),
            $siblingLocationSelect = $('.location-city select', $thisForm);

        function disableRegionInputs() {
            $stateProvinceSelect.attr('disabled', true);
            $siblingLocationSelect.attr('disabled', true);
        }

        function enableRegionInputs() {
            $stateProvinceSelect.attr('disabled', false);
            $siblingLocationSelect.attr('disabled', false);
            $siblingLocationSelect.selectpicker('refresh');
        }

        disableRegionInputs();

        $.ajax({
            type: "GET",
            url: "/wp-json/anytime/v1/find-locations/",
            dataType: 'json',
            data: {
                state_id: selectedStateId
            }
        }).done(function (data) {
            let totalResults = 0;
            $siblingLocationSelect.children().remove().end();
            $siblingLocationSelect.append('<option value="">' + translations.selectALocation + '</option>');
            $.each(data, function () {
                let newOptions = '<option value="' + this.afNumber + '" data-subtext="' + this.address + '" data-status_id="' + this.status_id + '">' + this.post_title + '</option>';
                $siblingLocationSelect.append(newOptions);
                totalResults++;
            });
            $siblingLocationSelect.attr('data-results-amount', totalResults);
            enableRegionInputs();
            disableStep2onMembershipInquiry();
            if ($(".special-privacy").length) {
                if ($('.special-privacy.'+ selectedStateAbbr + '.replace').length) { // if there is a div with .special-privacy + code + .replace: hide all other and show this one
                    $('.form-notes:not(.special-privacy.' + selectedStateAbbr + '.replace)').hide();
                    $('.form-group.local-requirements-questions:not(.special-privacy.' + selectedStateAbbr + '.replace)').hide();
                    $('.form-group.special-privacy:not(.' + selectedStateAbbr + '.replace)').hide();
                    $('.special-privacy.' + selectedStateAbbr + '.replace').show();
                } else if ($('.special-privacy.'+ selectedStateAbbr + '.add').length) { // if there is a div with .special-privacy + code + .add: hide all other and show default + this one
                    $('.special-privacy').hide();
                    $('.form-notes:not(.special-privacy)').show();
                    $('.form-group.local-requirements-questions:not(.special-privacy)').show();
                    $('.special-privacy.' + selectedStateAbbr + '.add').show();
                } else { // else hide all .special-privacy and show default
                    $('.special-privacy').hide();
                    $('.form-notes:not(.special-privacy)').show();
                    $('.form-group.local-requirements-questions:not(.special-privacy)').show();
                }
            }
        }).fail(function () {
            $siblingLocationSelect.children().remove().end();
            let newOptions = '<option value="">' + translations.noResults + '</option>';
            $siblingLocationSelect.append(newOptions);
            enableRegionInputs();
        }); // end ajax REST
    }); // end on change of stateProvince

    // populate second dropdown on page load if first dropdown has value
    if (selectedRegion != '') {
        $locationRegion.change();
    }

    // update formApp.gymID to be used for api
    $locationCity.on('change', function () {
        let selectedGymID = $(this).find("option:selected").val();
        if (selectedGymID) {
            enableStep2onMembershipInquiry();
        } else {
            disableStep2onMembershipInquiry();
        }
        formApp.gymID = selectedGymID;
        $('input[name="ClubId"]').val(formApp.gymID);
        if ($('input[name="need_bat"]').length) {
            if ($(this).find("option:selected").data('status_id') == '3') {
                $('input[name="need_bat"]').val("1");
            } else {
                $('input[name="need_bat"]').val("0");
            }
        }
    });

    $locationCity.on('shown.bs.select', function (e) {
        if (window.innerWidth <= 767 && $('.dropdown.bootstrap-select.inline-bs-select.location-city div.dropdown-menu').length && ($(".dropdown.bootstrap-select.inline-bs-select.location-city div.dropdown-menu").width()-$( window ).width()) > 0 ) {
            setTimeout(function () {
                $(".dropdown.bootstrap-select.inline-bs-select.location-city div.dropdown-menu").css('left', Math.round(($(".dropdown.bootstrap-select.inline-bs-select.location-city div.dropdown-menu").width()-$( window ).width())).toString() +'px');
            }, 10);
        }
    });
    $(window).on('scroll resize', function(e) {
        if (window.innerWidth <= 767 && $('.dropdown.bootstrap-select.inline-bs-select.location-city div.dropdown-menu.show').length && ($(".dropdown.bootstrap-select.inline-bs-select.location-city div.dropdown-menu").width()-$( window ).width()) > 0) {
            $('.form-container select.location-city').selectpicker('toggle');
        }
    });
    // INPUT FILE SELECTION
    $(document).on('change', '.btn-file :file', function () {
        let input = $(this),
            numFiles = input.get(0).files ? input.get(0).files.length : 1,
            label = input.val().replace(/\\/g, '/').replace(/.*\//, '');
        input.trigger('fileselect', [numFiles, label]);
    });

    $('.btn-file :file').on('fileselect', function (event, numFiles, label) {
        $('.file-upload-feedback-input').val(label);
    });

    $(window).on('resize', trainingBlockHeight);

    headerHeightPrevious = 0;
    resizeHeader = function () {
        let $headerMain = $('header.main'),
            $navTry = $('#nav-try-us-for-free'),
            headerPosition = '',
            headerHeight = 0,
            $promoBar = $('section.promo-bar:visible'),
            promoInTheTopHeight = 0,
            $section = $('section.behind-header'),
            sectionHeroAvailable,
            bodyPaddingTopNeed = 0,
            promoTop = 0,
            firstSectionHeroPaddingTop = 0,
            behindHeaderSectionPaddingTop = 0,
            $body = $('body'),
            $firstSectionHero = $('.promo-bar + .hero'),
            $behindHeaderSection = $('section.behind-header:first');

        // calculate header height
        if ($headerMain.length) {
            if (jQuery('body').hasClass('de')) {
                headerHeight = $headerMain.find('nav.navbar').outerHeight(true);
            } else {
                headerHeight = $headerMain.outerHeight(true);
            }
            headerPosition = $headerMain.css('position');
        }

        if (headerHeightPrevious !== headerHeight) {
            // only when Promo Bar on the top.
            if ($promoBar.length) {
                if (window.innerWidth >= Bootstrap.SCREEN_SM_MIN) {
                    if ($headerMain.length) {
                        promoInTheTopHeight = $promoBar.outerHeight(true);
                    }
                } else {
                    if (!$promoBar.hasClass('sticky_bottom')) {
                        $promoBar.css('position', 'inherit');
                    }
                }
            }

            if ($section.length === 0) {
                $section = $('section.hero');
            }

            // if doesn't use background image (section.hero) then change <body> padding-top
            sectionHeroAvailable = $section.length;

            if ('fixed' === headerPosition) {
                if (sectionHeroAvailable) {
                    firstSectionHeroPaddingTop += headerHeight;
                    behindHeaderSectionPaddingTop += headerHeight;
                    if (promoInTheTopHeight) {
                        promoTop += headerHeight;
                        firstSectionHeroPaddingTop += promoInTheTopHeight;
                        behindHeaderSectionPaddingTop += promoInTheTopHeight;
                    }
                } else {
                    bodyPaddingTopNeed += headerHeight;
                    if (promoInTheTopHeight) {
                        bodyPaddingTopNeed += promoInTheTopHeight;
                        promoTop += headerHeight;
                    }
                }
            } else if ('absolute' === headerPosition) {
                if (sectionHeroAvailable) {
                    firstSectionHeroPaddingTop += headerHeight;
                    behindHeaderSectionPaddingTop += headerHeight;
                    if (promoInTheTopHeight) {
                        promoTop += headerHeight;
                        firstSectionHeroPaddingTop += promoInTheTopHeight;
                        behindHeaderSectionPaddingTop += promoInTheTopHeight;
                    }
                } else {
                    bodyPaddingTopNeed += headerHeight;
                }
            }

            $promoBar.css('top', promoTop ? promoTop + 'px' : 'unset');
            $body.css('padding-top', bodyPaddingTopNeed ? bodyPaddingTopNeed + 'px' : 'inherit');
            $firstSectionHero.css('padding-top', firstSectionHeroPaddingTop ? firstSectionHeroPaddingTop + 'px' : 'inherit');
            if (behindHeaderSectionPaddingTop) {
                $behindHeaderSection.css('padding-top', behindHeaderSectionPaddingTop + 'px');
            } else {
                // new gyms hero template
                if (!$behindHeaderSection.hasClass("hero-v2")) {
                    $behindHeaderSection.css('padding-top', 'inherit');
                }
            }

        }

    };

    $(window).on('resize', resizeHeader);

    // additional resize after transition end.
    $('#menu-main-navigation').on('transitionend', resizeHeader);

    // One-time execution when DOM is ready.
    $(function () {
        $(window).trigger('resize');
    });

    // create instance
    app = new AF();

    // inits all sub elements
    app.init();

    // for the case when promo has images or external resource
    $(window).on("load", function() {
        recalcWhenPromo();
        scrollToHash(true);
        setPromoStickyTop();

    });

    $(window).on('hashchange resize', function(e) {
        // sometimes mobile browsers fires resize event on scroll (when scrollbar appears)
        if ((window.innerWidth > 767) || (window.innerWidth <= 767 && e.type != 'resize')) {
            scrollToHash(false);
        }
    });

    // Black Friday Campaign | Analytics & Segment
    $(window).on("load", function() {
        if (typeof analytics != "undefined") { // Segment
            let urlParams = new URLSearchParams(window.location.search);
            let utm_campaign = "";
            let utm_source = "";
            let utm_medium = "";

            if (urlParams.has('utm_campaign')) {
                utm_campaign = urlParams.get('utm_campaign');
            }
            if (urlParams.has('utm_source')) {
                utm_source = urlParams.get('utm_source');
            }
            if (urlParams.has('utm_medium')) {
                utm_medium = urlParams.get('utm_medium');
            }

            // Home Page
            if (translations.utmCodeForCampaign && utm_campaign && translations.utmCodeForCampaign == utm_campaign) {
                analytics.page("Page Event", {
                    "utm_campaign": utm_campaign,
                    "utm_source": utm_source,
                    "utm_medium": utm_medium,

                });
            }

            // Campaign Banner: User selects Black Friday campaign banner, button or link to landing page.
            $('a[href*="events/blackfriday"]').click(function(event) {
                analytics.track("Link Clicked", {
                    "brand": 			"anytimefitness",
                    "brand_channel": 	"website",
                    "cta":              $.trim($(this).text()),
                    "link_name":        "Link to Black Friday campaign page",
                    "link_type":        event.target.tagName,
                    "page_name": 		document.title,
                    "page_path": 		window.location.href
                });
            });

            if (window.location.href.indexOf("/events/blackfriday/") > -1) {
                // Campaign Page: User loads Black Friday campaign page.
                analytics.page("Page Event", {
                    "description": "User loads Black Friday campaign page",
                });

                // "Join Online" CTA button Clicked
                $('body').on('click', '.location-cta a.external-link', function() {
                    let $this = this;
                    analytics.track("Join Online Link Clicked", {
                        "brand": 			"anytimefitness",
                        "brand_channel": 	"website",
                        "location_id":      $($this).closest('li').data('location-club-id') ,
                        "page_name": 		document.title,
                        "page_path": 		window.location.href
                    });
                } );
            }
        }
        // "Join Online" CTA button Clicked
        if (window.location.href.indexOf("/events/blackfriday/") > -1) {
            $('body').on('click', '.location-cta a.external-link', function() {
                (window.dataLayer=window.dataLayer||[]).push({
                    'event' : 'blackfriday_join_online_clicked',
                    'club_id':      $(this).closest('li').data('location-club-id'),
                });
            });
        }
    });
});

jQuery(document).ready(function($) {
    function sticky_relocate_secondary() {
        if($('#sticky-anchor-secondary').length != 0 && $('#sticky-secondary').length != 0) {
            let window_top = $(window).scrollTop(),
                div_top = $('#sticky-anchor-secondary').offset().top +70;
            if (window_top > div_top) {
                //$('#sticky-secondary').addClass('stick');
                $('#sticky-secondary').addClass('d-block').insertBefore('#cta-header');
                $('#sticky-secondary').show();
            } else {
                //$('#sticky-secondary').removeClass('stick');
                $('#sticky-secondary').removeClass('d-block').appendTo('#sticky-anchor-secondary');
                $('#sticky-secondary').hide();
            }
        }
    }

    $(function() {
        $(window).scroll(sticky_relocate_secondary);
        sticky_relocate_secondary();
    });

    $('a.select-plan-link').click(function (e) {
        e.preventDefault();
        let self = $(this);
        // Snippet: Select Plan
        (window.dataLayer=window.dataLayer||[]).push({
            'event' : 'select_item',
            'plan_id': $(this).data("plan_id"), //optional
            'plan_name': $(this).closest(".align-items-stretch").find("h3.h4").text(),
            'price': $(this).closest(".align-items-stretch").find(".price .h4").text().replace('$', '') // number (float)
        });
        // end Snippet: Select Plan
        setTimeout(function() {
            window.location.href = self.attr("href");
        }, 1000);
    });

    $("#localResident").change(function() {
        let local_resident_checkbox_status = "";
        if(this.checked) {
            local_resident_checkbox_status = "checked";
        } else {
            local_resident_checkbox_status = "unchecked";
        }
        // send event Local Resident checkbox click to GA
        (window.dataLayer=window.dataLayer||[]).push({
            'event' : 'local_resident_checkbox_click',
            'checkbox_new_state': local_resident_checkbox_status
        });
    });

    if (typeof analytics != "undefined") {
        if (jQuery('#segment_anonymous_id').length > 0) {
            analytics.ready(function() {
                jQuery('#segment_anonymous_id').val( analytics.user().anonymousId() ) ;
            });
        }
        if (jQuery('#segment_user_id').length > 0) {
            analytics.ready(function() {
                jQuery('#segment_user_id').val( analytics.user().id() ) ;
            });
        }
    }
});

const localResidentModalBtn = document.getElementById("local_resident");
if(localResidentModalBtn) {
    localResidentModalBtn.addEventListener('click', function (e) {
        document.getElementById('local_resident_modal').classList.add('form-modal__show');
        e.preventDefault();
    });

    document.querySelector('.form-modal__close').addEventListener('click', function (e) {
        document.getElementById('local_resident_modal').classList.remove('form-modal__show');
        e.preventDefault();
    });

    document.querySelector('.form-modal').addEventListener('click', function (e) {
        document.getElementById('local_resident_modal').classList.remove('form-modal__show');
        e.preventDefault();
    });
}